import projects1 from './../assets/Projects/iqra-laptop-zone.png';
import projects2 from './../assets/Projects/dream-kitchen.png';
import projects3 from './../assets/Projects/pie-academy.png';

export const projects = [
    {
        name: 'Iqra Laptop Zone',
        description: `
            A Laptop resale website that can use three types of users – Admin, Seller, and Buyer.
            Implement JWT to protect API from unauthorized users. The seller can advertise
            their product on the home page. Users can buy a product using an authentic card.
        `,
        image: projects1,
        liveSite: 'https://iqra-laptop-zone.web.app/'
    },
    {
        name: 'Dream Kitchen',
        description: `
            A MERN Stack web application for a cloud kitchen owner which has authentication
            system for a user with private route. An authentic user can add review and new
            products. Without authentication a user cannot access protected APIs.
        `,
        image: projects2,
        liveSite: 'https://dream-kitchen-a0911.web.app/'
    },
    {
        name: 'Pie Academy',
        description: `
            Pie Academy is a CSE related courses selling website where a user can see course
            details and download course curriculum in pdf format. Without authentication user
            cannot get access checkout page.
        `,
        image: projects3,
        liveSite: 'https://pie-academy-auth.web.app/'
    },
]